import { render, staticRenderFns } from "./LocationPoster.vue?vue&type=template&id=30db2290&scoped=true&"
import script from "./LocationPoster.vue?vue&type=script&lang=ts&"
export * from "./LocationPoster.vue?vue&type=script&lang=ts&"
import style0 from "./LocationPoster.vue?vue&type=style&index=0&id=30db2290&scoped=true&lang=scss&"
import style1 from "./LocationPoster.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db2290",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
